var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bulk-actions"},[_c('div',{staticClass:"bulk-actions__container"},[_c('h2',[_vm._v("Style Bulk Creation")]),_c('StyleActions')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }